function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 12V4H24V12H72V4H84V12H96V52H84V88H92V92H4V88H12V52H0V12H12ZM24 52V88H72V52H24ZM24 20H16L8 44H16L24 20ZM56 20H48L40 44H48L56 20ZM88 20H80L72 44H80L88 20ZM40 20H32L24 44H32L40 20ZM72 20H64L56 44H64L72 20Z",
  fill: "url(#paint0_linear_1058_2558)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1058_2558",
  x1: 0,
  y1: 4,
  x2: 61,
  y2: 48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EC4899"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7C3AED"
})));

function SvgFinishedFailedImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishedFailedImage);
export default __webpack_public_path__ + "static/media/finishedFailedImage.c8f6115ed0b5f162ba0ce6d5fa4456e0.svg";
export { ForwardRef as ReactComponent };